import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserAccessService } from '../services/user-access.service';
import { canAccessPath, homePathForRole } from '../utils/rbac-routes.util';

export const authGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);
  const userAccess = inject(UserAccessService);

  if (!isPlatformBrowser(platformId)) {
    return false;
  }

  const loginToken =
    localStorage.getItem('TtZUw0Q87E647ac8j0gQHiCmBhczph') || '';

  if (!loginToken) {
    router.navigate(['/login']);
    return false;
  }

  return userAccess.fetchAccess().pipe(
    map((access) => {
      if (!access.role) return true;
      if (canAccessPath(access.role, state.url)) return true;
      return router.createUrlTree([homePathForRole(access.role)]);
    }),
  );
};
